import "./Divider.scss";
import PropTypes from "prop-types";

const Divider = ({ children }) => {
  return (
    <div className="divider__container">
      <div className="divider__border" />
      {children && <span className="divider__content">{children}</span>}
      <div className="divider__border" />
    </div>
  );
};

export default Divider;

Divider.propTypes = {
  children: PropTypes.node,
};
